module.exports = __webpack_public_path__ + "static/project-2-c5253d2f90329a017270c27e126bc31c.jpg";